export default "__VITE_ASSET__pRXrc9G7__"